export const baseHeaderAppName = 'The HiLight';
